import { oneOf } from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Box from '@mui/material/Box';
import {
  Close,
  FlowStep,
  NodeBackTime,
  NodeCalendar,
  NodeChain,
  NodeChat,
  NodeCondition,
  NodeCreditCard,
  NodeFilter,
  NodeHeads,
  NodeList,
  NodeSearch,
  NodeWindow,
  PanelClose,
  PanelOpen,
  SupportTicket,
  WhenThen,
} from '../../../assets/icons';
import ABTest from '../../../assets/icons/ABTest';
import Count from '../../../assets/icons/Count';
import PaymentMethod from '../../../assets/icons/PaymentMethod';
import Processing from '../../../assets/icons/Processing';
import Shield from '../../../assets/icons/Shield';
import ShoppingCart from '../../../assets/icons/ShoppingCart';
import THEME from '../../../constants/theme';
import Globe from '../../../assets/icons/QuickStart/Globe';
import Zap from '../../../assets/icons/Zap';

const ICON_MAP = {
  FlowStep: NodeFilter,
  FlowCondition: FlowStep,
  WhenThen: WhenThen,
  PanelClose: PanelClose,
  PanelOpen: PanelOpen,
  SupportAction: NodeList,
  PaymentAction: NodeCreditCard,
  FlowAction: NodeFilter,
  CommsAction: NodeChat,
  CORE_CRM_TICKET_TRIGGER: SupportTicket,
  SCHEDULED_TRIGGER: NodeCalendar,
  CORE_PAYMENT_TRIGGER: NodeCreditCard,
  WEBHOOK_TRIGGER: NodeChain,
  WEBHOOK_ACTION: NodeChain,
  FIND_LINKED_DATA_ACTION: NodeList,
  STEP_ACTION_DATALOOKUP: NodeSearch,
  STEP_ACTION_DATAEXPORT: NodeList,
  CORE_CARD_CONDITION: NodeCreditCard,
  CORE_INTENT_CONDITION: ShoppingCart,
  CORE_PAYMENT_CONDITION: NodeCondition,
  COLLECT: NodeWindow,
  CHARGE: NodeCreditCard,
  CAPTURE: NodeCreditCard,
  DELAY_ACTION: NodeBackTime,
  FLOW_STEP_COLLECT: NodeCreditCard,
  FLOW_STEP_CHARGE: NodeCreditCard,
  RULES_STEP: NodeFilter,
  USER_ACTION_CONDITION: NodeHeads,
  FLOW_STEP_PROCESSING_TRIGGER: Processing,
  FLOW_STEP_CHECKOUT: ShoppingCart,
  CUSTOM_CONDITION: NodeCondition,
  PAYMENT_METHOD_CONDITION: PaymentMethod,
  '3D_SECURE_STEP': Shield,
  COUNT_CONDITION_STEP: Count,
  AB_TEST_CONDITION_STEP: ABTest,
  ANNOTATION_STEP: null,
  GLOBAL_ICON: Globe,
  DISPUTE_TRIGGER: Zap,
  None: null,
};

const ICON_SIZES = {
  xs: 12,
  s: 16,
  m: 24,
  l: 40,
};

const IconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: ${({ $size }) => `${$size}px`} !important;
  }
`;

const Icon = ({ icon, size }) => {
  if (icon === 'None') return null;
  const IconComponent = ICON_MAP[icon] ?? Close;
  const sizePx = ICON_SIZES[size];
  return (
    <IconWrapper $size={sizePx}>
      <IconComponent color={THEME.primaryColors.white} size={sizePx} />
    </IconWrapper>
  );
};

Icon.propTypes = {
  icon: oneOf(Object.keys(ICON_MAP)).isRequired,
  size: oneOf(Object.keys(ICON_SIZES)),
};

Icon.defaultProps = {
  size: 'm',
};
export default Icon;
